import Main from './Main'

export default Main



// WEBPACK FOOTER //
// ./src/components/Main/index.js